import React, { useState, useEffect, useRef, useMemo, Fragment } from 'react'
import { connect } from 'react-redux'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import { authorization } from 'Module/Auth/Auth'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { RosterViewWrapper } from 'Components/Campaigns/RosterView/RosterViewWrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import {
  FILTER_MAP_DENSITY_ENUM,
  MISSION_ENUM_TYPES,
} from './../../../shared/constants'
import { deleteMissions } from './../../../Reducers/Mission/actions'
import { showReduxModal, hideReduxModal } from './../../../Reducers/UI/actions'
import { UNBOOK_OPTIONS } from '../../../constants'
import {
  getInitialOverlaysMapFromMissions,
  getBreadcrumbs,
  mergeAreaDataToTheMission,
  getMissionsUpdateResult,
  mergeInitialOverlaysData,
  mergeMissionsData,
  mergeVisibleOverlaysData,
  getMissionsDeletionData,
  NON_STARTED_STATUSES,
} from '../util'
import DrawMap from '../../../Components/DrawMap/container/DrawMap'
import { getNumberOfHouseholdsAndDensityForMissions } from '../../../Utils/Mission'
import DetailsSection from '../../../Components/DetailsSection/DetailsSection'
import BreadcrumbsRenderer from '../../../Components/BreadcrumbsRenderer/BreadcrumbsRenderer'
import MissionsControls from '../../../Components/MissionsControls/MissionsControls'
import { SelectDashboard } from '../../../Components/Form/SelectDashboard'
import {
  getEndOfWeek,
  formatToLocalDate,
} from '../../../shared/libraries/utils/date'
import LetterboxMissionsTable from '../blocks/LetterboxMissionsTable/container/LetterboxMissionsTable'
import { convertArrayToHashMap } from '../../../shared/libraries/dataSets'
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator'
import {
  getPostcodesForBoundaries,
  createOverlayName,
} from '../../../Utils/Map'
import { createMissions, updateMission } from '../../../Module/graphQL'
import { apiClient } from '../../../Module/API/Client'
import { getFeatureFromOverlay, getFormatedArea } from '../../BuilderMap/util'
import { getDetailsItems } from '../../../Components/DetailsSection/utils'
import Checkbox from '@material-ui/core/Checkbox'
import PostcodesSearch from '../../../Components/PostcodesSearch/component/PostcodesSearch'
import { debounce } from '../../../Utils/Functions/index'
import { BUILDER_MAP_MODE } from '../../BuilderMap/const'
import useOverlaysFetch from '../../../Utils/Hooks/useOverlaysFetch'
import BulkActions from '../../../Components/BulkActions'
import { onPublishDraftMissions } from '../../../Components/MissionsControls/utils'
import BulkEditMissionModalBody from '../../../Components/BulkActions/blocks/BulkEditMissionModalBody'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import { Typography } from '@material-ui/core'

const isClient = () => authorization.isClientRole()
let requestId = null
const mode = BUILDER_MAP_MODE.EDIT

const LetterboxMissions = props => {
  const {
    showReduxModal,
    city: {
      country: { code: countryCode, currencySign },
    },
  } = props
  const [processedMissionsMap, setProcessedMissionsMap] = useState({})
  const [initialOverlaysMap, setInitialOverlaysMap] = useState({})
  const [map, setMap] = useState(false)

  const [postcodes, setPostcodes] = useState({})

  const [initialDataLoaded, setInitialDataLoaded] = useState(false)
  const [unbookReason, setUnbookReason] = useState(UNBOOK_OPTIONS[0].value)
  const [visibleOverlaysMap, setVisibleOverlaysMap] = useState({})
  const [visibleMissionsIds, setVisibleMissionsIds] = useState([])
  const [visiblePostcodes, setVisiblePostcodes] = useState([])
  const processedMissionsMapRef = useRef()
  const [loading, setLoading] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState(
    FILTER_MAP_DENSITY_ENUM.ALL,
  )
  const [densityFilterLoaded, setDensityFilterLoaded] = useState(false)
  const { loadData } = useOverlaysFetch({ mode, countryCode })

  const filterOptions = Object.values(FILTER_MAP_DENSITY_ENUM).map(item => ({
    label: item,
    value: item,
  }))

  useEffect(() => {
    processedMissionsMapRef.current = processedMissionsMap
  }, [processedMissionsMap])

  useEffect(() => {
    mergeNewMissionsData(props.missions)
    setVisibleMissionsIds(props.missions.map(({ id }) => id))
  }, [props.missions])

  useEffect(() => {
    const visiblePostcodesIds = Object.values(postcodes).reduce(
      (acc, postcode) => {
        if (visiblePostcodes.includes(postcode.name)) acc.push(postcode.id)
        return acc
      },
      [],
    )

    const newVisibleOverlaysMap = [
      ...visiblePostcodesIds,
      ...visibleMissionsIds,
    ].reduce((acc, key) => {
      acc[key] = true
      return acc
    }, {})

    setVisibleOverlaysMap(newVisibleOverlaysMap)
  }, [visibleMissionsIds, visiblePostcodes])

  const onMapInit = newMap => {
    if (!newMap || map) return
    newMap.addListener(
      'bounds_changed',
      // Using debounce (1s) so we wont spam expensive requests
      debounce(() => fetchPostcodes(newMap), 1000),
    )
    fetchPostcodes(newMap)
    setMap(newMap)
  }

  const fetchPostcodes = async map => {
    // Don't fetch and trigger re-render if user is drawing
    // if (drawingStatusRef.current) return
    try {
      const latLngBound = map.getBounds()
      const zoom = map.getZoom()

      if (!latLngBound) return
      const formattedArea = await getFormatedArea(latLngBound)
      setLoading(true)

      const includeAddressCount = zoom > 14
      const currentRequestId = Date.now()
      requestId = currentRequestId

      const postcodes = await loadData({
        layer: 'Postcodes',
        area: formattedArea,
        includeAddressCount,
      })

      if (currentRequestId !== requestId) {
        //Race condition occurred
        return
      }
      setPostcodes(postcodes.data)
    } catch (error) {
      console.error('PathFinder error.')
      throw error
    } finally {
      setLoading(false)
    }
  }

  const mergeNewMissionsData = async rawMissions => {
    const { newMissionsMap, deletedMissionsIds } = getMissionsUpdateResult({
      receivedMissionsMap: convertArrayToHashMap(rawMissions, 'id'),
      existingMissionsMap: processedMissionsMap,
    })

    const mergedInitialOverlaysMap = mergeInitialOverlaysData({
      newData: getInitialOverlaysMapFromMissions(newMissionsMap, {
        isClient: isClient(),
      }),
      oldData: initialOverlaysMap,
      deletedIds: deletedMissionsIds,
    })

    const mergedMissionsMap = mergeMissionsData({
      newData: newMissionsMap,
      oldData: processedMissionsMap,
      deletedIds: deletedMissionsIds,
    })

    const mergedVisibleOverlaysMap = mergeVisibleOverlaysData({
      newData: newMissionsMap,
      oldData: visibleOverlaysMap,
      deletedIds: deletedMissionsIds,
    })
    setInitialOverlaysMap(mergedInitialOverlaysMap)
    setVisibleOverlaysMap(mergedVisibleOverlaysMap)

    setProcessedMissionsMap(
      convertArrayToHashMap(Object.values(mergedMissionsMap), 'id'),
    )

    setInitialDataLoaded(true)

    updateMissionsWithAreaInfo(
      Object.values(newMissionsMap),
      Object.values(mergedMissionsMap),
    )
  }

  const updateMissionsWithAreaInfo = async (
    missionsWithoutAreaInfo,
    processedMissions,
  ) => {
    try {
      const missionsAreaDataMap = await getNumberOfHouseholdsAndDensityForMissions(
        {
          missions: missionsWithoutAreaInfo.filter(mission => mission.boundary),
          countryCode: props.countryCode,
        },
      )
      const relatedPostcodes = await getPostcodesForBoundaries({
        geometries: missionsWithoutAreaInfo.reduce((acc, mission) => {
          // Get auto name only if mission is not named
          if (!mission.label) {
            const { geometry } = getFeatureFromOverlay({
              countryCode: props.countryCode,
              boundary: mission.boundary,
            })
            acc.push(geometry)
          }
          return acc
        }, []),
        countryCode: props.countryCode,
      })

      const missions = mergeAreaDataToTheMission({
        missions: processedMissions,
        missionsAreaDataMap,
        relatedPostcodes,
      })

      setProcessedMissionsMap(convertArrayToHashMap(missions, 'id'))
    } catch (error) {
      setProcessedMissionsMap(convertArrayToHashMap(processedMissions, 'id'))
      console.error(error)
    }
  }

  const deleteUnstartedMissionsById = async (
    missionsToBeDeletedIds,
    shouldUpdate = true,
  ) => {
    const { missionsToDelete, isAnyBooked } = getMissionsDeletionData(
      Object.values(processedMissionsMap),
      missionsToBeDeletedIds,
    )

    if (!missionsToDelete.length) return

    const payload = {
      unbookReason: unbookReason,
      missions: missionsToDelete.map(({ id }) => ({ id })),
    }

    if (!missionsToDelete.length) {
      return showReduxModal({
        title: `There is 0 non-started missions that can be deleted`,
        confirmLabel: `OK`,
        hideCancel: true,
      })
    }

    return new Promise(resolve => {
      showReduxModal({
        title:
          missionsToDelete.length === 1
            ? 'Delete 1 non-started mission'
            : `Delete ${missionsToDelete.length} non-started missions`,
        onConfirm: async () => {
          await apiClient.deleteMissions(payload)
          deleteMissionsFromState(payload.missions.map(({ id }) => id))

          resolve()
          if (shouldUpdate) {
            props.refetchMissions()
          }
        },
        children: isAnyBooked && (
          <div>
            <SelectDashboard
              label={'Reason:'}
              input={{ name: 'unbookMission', value: unbookReason }}
              options={UNBOOK_OPTIONS}
              onChange={(e, index, value) => setUnbookReason(value)}
            />
          </div>
        ),
        confirmLabel: 'Delete',
      })
    })
  }

  const updateMissionHandler = async missionInput => {
    const updateMissionResponse = await updateMission({ missionInput })
    const updateMissionResult = await updateMissionResponse.json()
    return updateMissionResult.data.updateMission.mission
  }
  /**
   * Saves or updates existing mission with received data
   * @param {number} param.id If passed then mission will be updated if no - new mission will be created
   * @param {string} param.color Overlay's color
   * @param {array} param.boundary Mission's boundary
   * @param {date} param.date Mission's start date (week)
   *
   * @returns {object} Created or update mission
   *
   * @example
   * onOverlaySave({
   *  id: 1,
   *  color: "#000",
   *  boundary: [{ latitude: 1, longitude: 1 }, { latitude: 2, longitude: 2}, { latitude: 3, longitude: 3 }],
   *  date: DateObject
   * })
   */
  const onOverlaySave = async ({
    id,
    color,
    boundary,
    date,
    label,
    overlay,
  }) => {
    try {
      const { countryCode } = props
      const { cityPlanId } = props.match.params

      const name =
        label && label.length > 0
          ? label
          : await createOverlayName({
              countryCode,
              boundary,
              renderedOverlays: Object.values(processedMissionsMap),
            })
      overlay.set('payload', { ...overlay.payload, label: name })

      // If mission already exists then update it
      if (id) {
        const updateMissionInput = {
          id,
          boundary,
          boundaryColour: color,
          dateTime: date
            ? formatToLocalDate(getEndOfWeek(new Date(date)))
            : undefined,
          label: name,
        }
        const updatedMission = await updateMissionHandler(updateMissionInput)

        mergeNewMissionsData(
          Object.values({
            ...processedMissionsMapRef.current,
            [updatedMission.id]: updatedMission,
          }),
        )
        return updatedMission
      }

      const createMissionInput = {
        cityPlanId: Number(cityPlanId),
        type: MISSION_ENUM_TYPES.LETTERBOX,
        dateTime: formatToLocalDate(getEndOfWeek(new Date())),
        // LB specifics
        boundary,
        boundaryColour: color,
        label: name,
      }

      const [mission] = await createMissions([createMissionInput])

      mergeNewMissionsData(
        Object.values({
          ...processedMissionsMapRef.current,
          [mission.id]: mission,
        }),
      )
      return mission
    } catch (error) {
      throw new Error(error)
    }
  }
  // Get details rows that we want to render
  const detailsItemsData = getDetailsItems({
    missions: Object.values(processedMissionsMap),
  })
  // Get breadcrumbs items that we want to render
  const breadcrumbsData = getBreadcrumbs({
    campaign: props.campaign,
    cityPlanId: props.match.params.cityPlanId,
    campaignId: props.match.params.campaignId,
    city: props.city,
  })

  const handleCheckboxChange = missionId =>
    setVisibleMissionsIds(visibleIds => {
      const cloneVisibleIds = [...visibleIds]
      if (cloneVisibleIds.includes(missionId)) {
        return cloneVisibleIds.filter(id => missionId !== id)
      } else {
        cloneVisibleIds.push(missionId)
        return cloneVisibleIds
      }
    })

  const onTableDataUpdate = ({ displayedData: visibleMissionsIds }) => {
    const visibleIds = visibleMissionsIds.map(({ id }) => id)
    setVisibleMissionsIds(visibleIds)

    const { newVisibleOverlaysMap, isIdenticalToPreviousData } = Object.keys(
      visibleOverlaysMap,
    ).reduce(
      (acc, missionId) => {
        const isVisible = visibleIds.includes(missionId)

        if (visibleOverlaysMap[missionId] !== isVisible) {
          acc.newVisibleOverlaysMap[missionId] = isVisible
          acc.isIdenticalToPreviousData = false
        }
        return acc
      },
      {
        newVisibleOverlaysMap: { ...visibleOverlaysMap },
        isIdenticalToPreviousData: true,
      },
    )

    // If no new missions was checked/unchecked - do nothing
    if (isIdenticalToPreviousData) return

    setVisibleOverlaysMap(newVisibleOverlaysMap)
  }

  const onRowDelete = async id => {
    const payload = {
      unbookReason: undefined,
      missions: [{ id }],
    }
    deleteMissionsFromState([id])
    await apiClient.deleteMissions(payload)
  }

  const deleteMissionsFromState = missionsToBeDeletedIds => {
    const clone = { ...processedMissionsMap }
    missionsToBeDeletedIds.forEach(id => {
      delete clone[id]
    })

    mergeNewMissionsData(Object.values(clone))
  }

  /**
   * checks if all overlays selected
   * @returns {boolean} true if all overlays selected
   */
  const checkIfAllOverlaysSelected = () => {
    return Object.keys(visibleOverlaysMap).reduce((acc, key) => {
      const isSelected = visibleOverlaysMap[key]
      if (isSelected) acc = true
      return acc
    }, false)
  }

  /**
   * Set visible missions overlays according to checkbox value
   * @param {boolean} value of checkbox
   */
  const toggleAllMissionsOverlaysVisiblity = (e, value) => {
    setVisibleMissionsIds(
      value ? Object.keys(processedMissionsMapRef.current) : [],
    )
  }

  const onPostcodesUpdate = ({ activeTags }) => setVisiblePostcodes(activeTags)

  const showClearBtn = useMemo(() =>
    Object.values(processedMissionsMap).find(
      mission => mission.id && NON_STARTED_STATUSES.includes(mission.status),
    )
      ? true
      : false,
  )

  const onBulkPublish = () => {
    onPublishDraftMissions({
      campaign: props.campaign,
      missions: Object.values(processedMissionsMap).filter(mission =>
        visibleMissionsIds.includes(mission.id),
      ),
      showReduxModal,
      updateData: () => props.refetchMissions(),
    })
  }

  const onBulkEdit = () => {
    const missionsToEdit = Object.values(
      processedMissionsMapRef.current,
    ).filter(mission => visibleMissionsIds.includes(mission.id))

    const text = missionsToEdit.some(mission => mission.canBeSpied)
      ? 'The missions would be removed from the spy shift if you change date or location'
      : null

    showReduxModal({
      title: `Edit ${visibleMissionsIds.length} missions`,
      children: (
        <Fragment>
          {text ? (
            <Typography align="center" style={{ marginBottom: 20 }}>
              {text}
            </Typography>
          ) : null}
          <BulkEditMissionModalBody
            missionsToEdit={missionsToEdit}
            onClose={() => props.refetchMissions()}
            currencySign={currencySign}
          />
        </Fragment>
      ),
      hideButtons: true,
    })
  }

  const onBulkDelete = async () =>
    deleteUnstartedMissionsById(visibleMissionsIds, false)

  return (
    <HideWhenBlocked>
      <RosterViewWrapper>
        <LayoutDashboard>
          <BreadcrumbsRenderer
            icon={breadcrumbsData.icon}
            items={breadcrumbsData.items}
          />
          <PageTitle>Letterbox Missions</PageTitle>
          <MissionsControls
            missions={Object.values(processedMissionsMap)}
            campaign={props.campaign}
            updateData={() => props.refetchMissions()}
          />
          <DetailsSection items={detailsItemsData} />
          {initialDataLoaded ? (
            <section>
              <Row>
                <Col xs={4}>
                  <SelectDashboard
                    options={filterOptions}
                    value={selectedFilter}
                    onChange={(a, b, value) => {
                      setSelectedFilter(value)
                    }}
                    disabled={!densityFilterLoaded}
                  />
                </Col>
                <Col xs={8}>
                  <PostcodesSearch
                    countryCode={props.countryCode}
                    onUpdate={onPostcodesUpdate}
                  />
                </Col>
              </Row>

              <DrawMap
                onMapInit={onMapInit}
                onSave={onOverlaySave}
                initialOverlays={Object.values({
                  ...initialOverlaysMap,
                  ...postcodes,
                })}
                mapOptions={{
                  center: {
                    lat: props.city.latitude,
                    lng: props.city.longitude,
                  },
                }}
                onDelete={(overlays, shouldUpdate) =>
                  deleteUnstartedMissionsById(
                    overlays.reduce(
                      (acc, { customId, canBeDeleted, isPostcode }) =>
                        canBeDeleted && !isPostcode ? [...acc, customId] : acc,
                      [],
                    ),
                    shouldUpdate,
                  )
                }
                loading={loading}
                hideMapControls={isClient()}
                countryCode={props.countryCode}
                visibleOverlaysMap={visibleOverlaysMap}
                mapControls={showClearBtn ? ['DRAW', 'CLEAR_ALL'] : ['DRAW']}
                clearAllLabel={'Delete non-started'}
                filter={selectedFilter}
                onFilterLoaded={setDensityFilterLoaded}
              />
              <br />
              <Grid container spacing={2}>
                <Grid item>
                  <BulkActions
                    onPublish={onBulkPublish}
                    onEdit={onBulkEdit}
                    onDelete={onBulkDelete}
                    disabled={!Object.keys(visibleOverlaysMap).length}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={true}
                        checked={checkIfAllOverlaysSelected()}
                        onChange={toggleAllMissionsOverlaysVisiblity}
                      />
                    }
                    label="Select all missions"
                  />
                </Grid>
              </Grid>
              <LetterboxMissionsTable
                missions={Object.values(processedMissionsMap).map(mission => ({
                  ...mission,
                  city: props.city, // For BA link
                }))}
                onCheckboxChange={handleCheckboxChange}
                history={props.history}
                match={props.match}
                checkboxesMap={visibleOverlaysMap}
                onTableDataUpdate={onTableDataUpdate}
                onDelete={onRowDelete}
              />
            </section>
          ) : (
            <LoadingIndicator />
          )}
        </LayoutDashboard>
      </RosterViewWrapper>
    </HideWhenBlocked>
  )
}

const mapDispatchToProps = {
  deleteMissions,
  showReduxModal,
  hideReduxModal,
}

export default connect(
  null,
  mapDispatchToProps,
)(LetterboxMissions)



// WEBPACK FOOTER //
// ./src/Containers/LetterboxMissions/container/LetterboxMissions.js